import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const TodoList: AppRouteRecordRaw = {
  path: '/todoTask',
  name: 'todoTask',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '待办任务',
    requiresAuth: true,
    order: 6,
  },
  children: [
    {
      path: 'todoList',
      name: 'TodoList',
      component: () => import('@/views/todoList/index.vue'),
      meta: {
        title: '待办列表',
        requiresAuth: true,
        hideInMenu: true,
        roles: [
          'todoTaskGetScope',
          'todoTaskGetScopeAll',
          'todoTaskGetScopeSelfDepartment',
          'todoTaskGetScopeSelf',
        ],
        activeMenu: 'TodoList',
        permissionMode: 'some',
      },
    },
  ],
};

export default TodoList;
